export const users = [
    {
        "log":"commercial@gmail.com",
        "password":"abonneuser",
        "role":"cmrc",
        "comp":"wam"
    },{
        "log":"admin@gmail.com",
        "password":"abonneuser",
        "role":"adm",
        "comp":"itimdex"
    }
]